import React, { useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import {  Col, Row, Typography } from 'antd'

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  DownOutlined
} from "@ant-design/icons";

const Question = () => {

  const items = [
    {
      key: '1',
      label: '1. Why should I become a member?',
      children: <p>You earn Points every time you buy a holiday from plan mi trip, You can earn up to 2% of your total net payable, back as reward points, depending on the tier you are in. Refer the program structure in ‘About the Program’ for details on points accrual. You get to redeem those points on your next Flight, Hotel or Holiday booking. Get access to all offers, new product launches, customer events exclusively before they are rolled out to everyone else. You enjoy access to partner offers. Chance to earn bonus points from time to time on promotional campaigns and Get surprise benefits on your birthdays’ anniversaries & other special occasions.</p>,
    },
    {
      key: '2',
      label: '2. How do I become a member?',
      children: <p>Once you have booked your first holiday with us post Jan of 2024, you are eligible to become a member and enroll yourself into the silver tier of the program. You need to log onto Plan mi trip and share a few basic details with us and you are automatically enrolled into the program.</p>,
    },
    {
      key: '3',
      label: '3. Does it cost to join “Plan mi trip” ?',
      children: <p>No, membership is complimentary, for anyone who has booked a holiday at least once with us.</p>,
    },
    {
      key: '4',
      label: '4. What are the different levels & benefits at each membership level?',
      children: <p>There are 2 tiers – Silver & Gold. A Silver member earns 1% of the sales value of the holiday booked as loyalty points. If the sales value exceeds Rs.15 Lac, there is a bonus of 0.5%. A Gold member earns 1.5% of the sales value of the holiday booked as loyalty points. If the sales value exceeds Rs.15 Lac, there is a bonus of 0.5%.</p>,
    },
    {
      key: '5',
      label: '5. How do I check my available rewards points and exclusive offers?',
      children: <p>It's simple. You log into the plan mi trip and enter your mobile number and you will be shown a full history of your points accrued, utilized and balance that are available to be redeemed.</p>,
    },
    {
      key: '6',
      label: '6. Can I share my membership with others?',
      children: <p>Membership or the points are non-transferable and limited to the registered member only. However, you can always refer your friends and family to join the “plan mi trip” and enjoy the referral benefits.</p>,
    },
    {
      key: '7',
      label: '7. How many days after departure are my points credited into my account?',
      children: <p>Points will be reflecting in your account within 20 days of your travel date.</p>,
    },
    {
      key: '8',
      label: '8. What if I am missing credits on my account?',
      children: <p>You may write to us on planmitrip.in and we will check your history and reinstate your points if they are not reflecting in your account due to whatever reason.</p>,
    },
    {
      key: '9',
      label: '9. How can I contact customer support?',
      children: <p>You can write to us on planmitrip.in in case of any issues, complaints or suggestions and we will reach out to you.</p>,
    },
    {
      key: '10',
      label: '10. How long does the membership last?',
      children: <p>Membership is valid for 18 months. If you don’t transact for any of our products, namely flights, hotels, or holidays, to burn your existing points, your membership and the points will expire after 18 months. But even if you make a single transaction on any of our products within the 18 months, you can retain your membership tier, and your points will continue to remain valid.</p>,
    },
    {
      key: '11',
      label: '11. Can I cancel my membership?',
      children: <p>No, the membership is non-cancellable but since it’s a free membership, there is no need to cancel, even if you don’t intend to travel with us in future. It will anyways lapse after a period of 18 months.</p>,
    },
  ];

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div style={{ fontFamily: "Roboto, sans-serif" }}>
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: 'center',
        marginTop:"40px"
      }}>
        <Typography  style={{
          fontSize:"22px",
          fontStretch:"expanded",
          fontWeight: 'bold',
          color: '#1a4073',
          fontFamily: "Roboto, sans-serif"
        }}>
          FREQUENTLY ASKED QUESTIONS
        </Typography>
        <div style={{
          width: "60px",
          height: "2px",
          backgroundColor: '#1a4073',
          marginTop: "5px"
        }} />
      </div>

      <Row style={{
        display: "flex",
        justifyContent: "center",
        marginTop: 20
      }}>
        <Col sm={20} xs={24}
         style={{
          maxWidth: 850,
          width: '100%',
          padding: 20
        }}>
          {items.map(item => (
            <Accordion
              key={item.key}
              style={{ margin: 0 }}
              expanded={expanded === `panel${item.key}`}
              onChange={handleChange(`panel${item.key}`)}
            >
              <AccordionSummary
                expandIcon={
                  <DownOutlined
                    style={{
                      fontSize: '1.2rem',
                      fontWeight:'bold',
                      color: expanded === `panel${item.key}` ? 'skyblue' : 'inherit',
                      transition: 'color 0.3s ease'
                    }}
                  />
                }
                aria-controls={`panel${item.key}-content`}
                id={`panel${item.key}-header`}
              >
                <Typography style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  padding:"3px", 
                  fontFamily: "Roboto, sans-serif", 
                  color:"#000"
                }}>{item.label}</Typography>
              </AccordionSummary>
              <AccordionDetails style={{ padding: 'opx 16px',fontSize: "15px", marginBottom:"5PX" ,fontFamily: "Roboto, sans-serif", color:"#000"}}>
                {item.children}
              </AccordionDetails>
            </Accordion>
          ))}
        </Col>
      </Row>
    </div>
  );
}


export default Question


